export default () => `
  {
    currentOrder {
      number
      completedAt
      containsSocks
      items {
        sku
        variantId
        color
        groupName
        imageUrl
        price
        productPath
        productType
        quantity
        size
        stock
      }

      promotionAdjustment {
        code
        amount
        currency
      }
    }
  }
`
